/* Kreator zestawu Snüz (snippets/snuz-bundle-builder.liquid).
 *
 * Rysuje kroki z JSON-a wystawionego przez Liquid i na końcu wysyła cały
 * komplet jednym żądaniem do /cart/add.js.
 *
 * UKŁAD
 * Jeden zestaw węzłów obsługuje telefon i desktop; różnicę robi CSS. Na
 * telefonie podsumowanie jest arkuszem wysuwanym z dołu, a jedyny przycisk
 * "Dalej" siedzi w stałym pasku — krok z dziewięcioma kolorami jest dłuższy
 * niż ekran i przycisk pod listą byłby nieosiągalny bez przewijania. Na
 * desktopie podsumowanie wraca do kolumny obok, pasek znika, a nawigacja
 * kroków ląduje pod panelem.
 *
 * CZEGO TU NIE MA
 * Reguły "czy produkt jest na zamówienie i na kiedy" — przychodzi gotowa
 * w leadTimes, policzona przez made-to-order-notice.liquid. Tutaj tylko
 * odczyt, tak samo jak w made-to-order.js na karcie produktu.
 *
 * DOSTĘPNOŚĆ WARIANTU
 * variant.available == false znaczy "nie da się kupić" i tylko wtedy
 * wygaszamy opcję. Wariant bez stanu, ale ze sprzedażą po wyczerpaniu, ma
 * available == true — to jest właśnie przypadek "na zamówienie" i musi
 * zostać klikalny, bo pełna paleta kolorów to główny argument tej strony.
 *
 * KOSZYK
 * Motyw odświeża szufladę sam przy otwarciu, więc po dodaniu wystarczy
 * kliknąć jej trigger — nie ma potrzeby przerysowywania koszyka ręcznie.
 * Gdyby fetch padł, zostaje natywny submit formularza na /cart/add.
 */
(function () {
function initBuilder() {
  var root = document.querySelector('[data-snzw]');
  if (!root) return;

  /* Edytor motywu potrafi wywołać shopify:section:load bez podmiany naszego
     poddrzewa — bez tej flagi podpięlibyśmy słuchacze drugi raz na tych
     samych węzłach i jeden klik liczyłby się podwójnie. */
  if (root.getAttribute('data-snzw-ready')) return;
  root.setAttribute('data-snzw-ready', '1');

  var configEl = root.querySelector('[data-snzw-config]');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }
  if (!config.products || !config.products.length) return;

  var form = root.querySelector('[data-snzw-form]');
  var progressLabel = root.querySelector('[data-snzw-progress-label]');
  var progressTrack = root.querySelector('[data-snzw-progress-track]');
  var panelsEl = root.querySelector('[data-snzw-panels]');
  var summaryEl = root.querySelector('[data-snzw-summary]');
  var summaryList = root.querySelector('[data-snzw-summary-list]');
  var totalEl = root.querySelector('[data-snzw-total]');
  var shippingEl = root.querySelector('[data-snzw-shipping]');
  var submitEl = root.querySelector('[data-snzw-submit]');
  var noteEl = root.querySelector('[data-snzw-note]');
  var backdropEl = root.querySelector('[data-snzw-backdrop]');
  var sheetCloseEl = root.querySelector('[data-snzw-sheet-close]');
  var barEl = root.querySelector('[data-snzw-bar]');
  var barSummaryEl = root.querySelector('[data-snzw-bar-summary]');
  var barCount = root.querySelector('[data-snzw-bar-count]');
  var barTotal = root.querySelector('[data-snzw-bar-total]');
  var backEl = root.querySelector('[data-snzw-back]');
  var nextEl = root.querySelector('[data-snzw-next]');

  /* 0 znaczy "próg nieustawiony" — wtedy w ogóle nie obiecujemy darmowej
     dostawy, zamiast zgadywać kwotę. */
  var threshold = parseInt(root.getAttribute('data-free-shipping-threshold'), 10) || 0;

  var byKey = {};
  config.products.forEach(function (p) { byKey[p.key] = p; });

  /* Kroki. "required" ma tylko baza — bez niej nie wiadomo, co pasuje dalej;
     każdy kolejny krok da się pominąć, bo klient może już mieć prześcieradła
     albo nie chcieć śpiworka. */
  var STEPS = [
    {
      key: 'base',
      label: 'Łóżeczko',
      required: true,
      heading: 'Zacznij od bazy',
      hint: 'Materac jest w komplecie z każdą z nich. Ten wybór decyduje, co pasuje w kolejnych krokach.'
    },
    {
      key: 'protector',
      label: 'Ochraniacz',
      heading: 'Ochraniacz na materac — ważny dodatek',
      hint: 'Producent zaleca go przy każdym łóżeczku, ale nie dokłada do zestawu. Chroni materac przed ulewaniem i przeciekami.'
    },
    {
      key: 'sheets',
      label: 'Prześcieradła',
      heading: 'Prześcieradła — dwupak',
      hint: 'Jedno na łóżeczku, drugie czyste w szafie. O trzeciej w nocy nie ma czasu na pranie.'
    },
    {
      key: 'pouch',
      label: 'Śpiworek',
      heading: 'Śpiworek zamiast kocyka',
      hint: 'TOG 1.0 na ciepłe noce (21–23°C), TOG 2.5 na standardowe 16–20°C — czyli przez większość roku.'
    },
    {
      key: 'extras',
      label: 'Akcesoria',
      multi: true,
      heading: 'Akcesoria, które zmieniają noce',
      hint: 'Możesz wybrać oba albo żadne.'
    }
  ];

  /* presetKeys ustawia się tylko przy wejściu z ?zestaw= i zawęża krok 1 do
     bazy z tego zestawu — klient, który kliknął "Kosz na drzemki", nie ma po co
     oglądać dwóch łóżeczek, których nie wybrał. Zerujemy je, gdy poprosi
     o pełną listę, więc zawężenie nigdy nie jest ślepą uliczką. */
  var state = { step: 0, picks: {}, presetKeys: null };

  /* ── Formatowanie ceny ─────────────────────────────────────────────
     Przechodzimy przez shop.money_format zamiast twardego "zł" albo
     Intl.NumberFormat, żeby kwoty w kreatorze wyglądały identycznie jak
     wszędzie indziej w sklepie. */
  function formatMoney(cents) {
    var value = (cents || 0) / 100;

    function withDelimiters(decimalSep, thousandsSep, precision) {
      var parts = value.toFixed(precision).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
      return parts[1] ? whole + decimalSep + parts[1] : whole;
    }

    var fmt = config.moneyFormat || '{{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return withDelimiters('.', ',', 2);
        case 'amount_no_decimals': return withDelimiters('.', ',', 0);
        case 'amount_with_comma_separator': return withDelimiters(',', '.', 2);
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(',', '.', 0);
        case 'amount_with_apostrophe_separator': return withDelimiters('.', "'", 2);
        default: return withDelimiters('.', ',', 2);
      }
    });
  }

  function plural(n, one, few, many) {
    if (n === 1) return one;
    var mod10 = n % 10;
    var mod100 = n % 100;
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
    return many;
  }

  /* ── Dane ─────────────────────────────────────────────────────────── */

  function baseKey() {
    return state.picks.base ? state.picks.base.key : null;
  }

  /* Produkt należy do kroku i pasuje do wybranej bazy. "*" znaczy
     "do każdej bazy" — śpiworek i SnuzCloud nie są przypisane do posłania. */
  function productsForStep(stepKey) {
    var base = baseKey();
    return config.products.filter(function (p) {
      if (p.step !== stepKey) return false;
      if (stepKey === 'base') {
        /* Zawężamy tylko bazy. Kolejne kroki zostają pełne, żeby zestaw dało
           się rozbudować o rzeczy, których w presecie nie było. */
        if (state.presetKeys) return state.presetKeys.indexOf(p.key) !== -1;
        return true;
      }
      if (p.compat === '*') return true;
      return base && p.compat.split(',').indexOf(base) !== -1;
    });
  }

  function variantById(product, id) {
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === id) return product.variants[i];
    }
    return null;
  }

  function firstBuyable(product) {
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return product.variants[0];
  }

  function leadFor(product, variantId) {
    var table = product.leadTimes || {};
    var entry = table[String(variantId)];
    return entry && entry.active ? entry : null;
  }

  /* Wybrane pozycje w kolejności kroków — używane i w podsumowaniu,
     i przy budowaniu koszyka, żeby oba pokazywały to samo. */
  function selectedItems() {
    var out = [];
    STEPS.forEach(function (step) {
      var pick = state.picks[step.key];
      if (!pick) return;
      var list = step.multi ? pick : [pick];
      list.forEach(function (entry) {
        var product = byKey[entry.key];
        if (!product) return;
        var variant = variantById(product, entry.variantId);
        if (!variant) return;
        out.push({ product: product, variant: variant, lead: leadFor(product, variant.id) });
      });
    });
    return out;
  }

  function total() {
    return selectedItems().reduce(function (sum, item) { return sum + item.variant.price; }, 0);
  }

  /* ── Wybór ────────────────────────────────────────────────────────── */

  function setPick(stepKey, productKey, variantId) {
    var step = STEPS.filter(function (s) { return s.key === stepKey; })[0];

    if (step.multi) {
      var current = state.picks[stepKey] || [];
      var idx = -1;
      current.forEach(function (entry, i) { if (entry.key === productKey) idx = i; });
      if (idx === -1) {
        current = current.concat([{ key: productKey, variantId: variantId }]);
      } else if (variantId === null) {
        current = current.filter(function (_, i) { return i !== idx; });
      } else {
        current = current.slice();
        current[idx] = { key: productKey, variantId: variantId };
      }
      state.picks[stepKey] = current.length ? current : null;
    } else if (variantId === null) {
      state.picks[stepKey] = null;
    } else {
      state.picks[stepKey] = { key: productKey, variantId: variantId };
    }

    /* Zmiana bazy unieważnia wszystko, co było do niej dobrane — inaczej
       w koszyku wylądowałyby prześcieradła SnuzBaskit do SnuzPod5. */
    if (stepKey === 'base') {
      STEPS.forEach(function (s) {
        if (s.key === 'base') return;
        var pick = state.picks[s.key];
        if (!pick) return;
        var entries = s.multi ? pick : [pick];
        var kept = entries.filter(function (entry) {
          return productsForStep(s.key).some(function (p) { return p.key === entry.key; });
        });
        state.picks[s.key] = kept.length ? (s.multi ? kept : kept[0]) : null;
      });
    }

    render();
  }

  /* ── Rysowanie ────────────────────────────────────────────────────── */

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function isStepDone(step) {
    if (step.key === 'base') return !!state.picks.base;
    return state.picks[step.key] != null;
  }

  /* Segmenty zamiast klikalnej szyny z etykietami: pięć nazw kroków nie mieści
     się w szerokości telefonu. Skok do dowolnego kroku i tak jest możliwy —
     przez "Wstecz" oraz przez kliknięcie segmentu już odwiedzonego. */
  function renderProgress() {
    var step = STEPS[state.step];
    progressLabel.textContent = 'Krok ' + (state.step + 1) + ' z ' + STEPS.length + ' · ' + step.label;

    progressTrack.innerHTML = '';
    STEPS.forEach(function (s, i) {
      var li = el('li', 'snzw-progress-seg' +
        (i === state.step ? ' is-current' : '') +
        (i !== state.step && isStepDone(s) ? ' is-done' : ''));
      progressTrack.appendChild(li);
    });
  }

  function isPicked(stepKey, productKey) {
    var pick = state.picks[stepKey];
    if (!pick) return false;
    if (Array.isArray(pick)) return pick.some(function (e) { return e.key === productKey; });
    return pick.key === productKey;
  }

  function pickedVariantId(stepKey, productKey) {
    var pick = state.picks[stepKey];
    if (!pick) return null;
    var entries = Array.isArray(pick) ? pick : [pick];
    var found = entries.filter(function (e) { return e.key === productKey; })[0];
    return found ? found.variantId : null;
  }

  /* Karta jednego produktu w kroku: nagłówek, opcje i przełącznik wyboru. */
  function renderProductCard(step, product) {
    var card = el('div', 'snzw-card' + (isPicked(step.key, product.key) ? ' is-selected' : ''));

    var chosenId = pickedVariantId(step.key, product.key);
    var shown = chosenId ? variantById(product, chosenId) : firstBuyable(product);

    var head = el('div', 'snzw-card-head');
    var thumb = el('div', 'snzw-card-thumb');
    var img = document.createElement('img');
    img.src = shown && shown.image ? shown.image : product.image;
    img.alt = product.title;
    img.loading = 'lazy';
    img.width = 300;
    img.height = 300;
    thumb.appendChild(img);
    head.appendChild(thumb);

    var headBody = el('div', 'snzw-card-body');
    headBody.appendChild(el('p', 'snzw-card-title', product.title));
    headBody.appendChild(el('p', 'snzw-card-price', shown ? shown.priceFormatted : ''));

    var lead = shown ? leadFor(product, shown.id) : null;
    if (lead) {
      headBody.appendChild(el('p', 'snzw-card-lead', 'Na zamówienie · wysyłka ' + lead.range));
    }

    var link = el('a', 'snzw-card-link', 'Szczegóły produktu');
    link.href = product.url;
    link.target = '_blank';
    link.rel = 'noopener';
    headBody.appendChild(link);

    head.appendChild(headBody);
    card.appendChild(head);

    if (!product.hasOnlyDefaultVariant) {
      card.appendChild(renderOptions(step, product));
    }

    var action = el('div', 'snzw-card-action');
    var toggle = el('button', 'snzw-card-toggle');
    toggle.type = 'button';
    var picked = isPicked(step.key, product.key);
    toggle.textContent = picked ? (step.key === 'base' ? 'Wybrane' : 'Dodane do zestawu') : (step.key === 'base' ? 'Wybieram' : 'Dodaj do zestawu');
    toggle.setAttribute('aria-pressed', picked ? 'true' : 'false');
    toggle.addEventListener('click', function () {
      if (picked && step.key !== 'base') {
        setPick(step.key, product.key, null);
      } else {
        var target = chosenId || (firstBuyable(product) || {}).id;
        if (target) setPick(step.key, product.key, target);
      }
    });
    action.appendChild(toggle);
    card.appendChild(action);

    return card;
  }

  /* Siatka opcji. Rysujemy każdą opcję produktu osobno i po kliknięciu
     szukamy wariantu, który zgadza się na wszystkich pozycjach naraz —
     dzięki temu ten sam kod obsługuje i sam kolor, i kolor z TOG-iem. */
  function renderOptions(step, product) {
    var wrap = el('div', 'snzw-options');
    var chosenId = pickedVariantId(step.key, product.key);
    var current = (chosenId ? variantById(product, chosenId) : firstBuyable(product)) || product.variants[0];

    product.optionNames.forEach(function (optionName, optionIndex) {
      var values = [];
      product.variants.forEach(function (v) {
        var value = v.options[optionIndex];
        if (value && values.indexOf(value) === -1) values.push(value);
      });
      if (values.length < 2) return;

      var group = el('div', 'snzw-option');
      var label = el('p', 'snzw-option-name');
      label.appendChild(document.createTextNode(optionName + ': '));
      label.appendChild(el('span', null, current.options[optionIndex] || ''));
      group.appendChild(label);

      var list = el('div', 'snzw-option-values');

      values.forEach(function (value) {
        /* Wariant docelowy: ten sam zestaw opcji co teraz, tylko z podmienioną
           jedną pozycją. Gdy taka kombinacja nie istnieje (np. dany kolor nie
           ma TOG 1.0), bierzemy pierwszy wariant z tą wartością, żeby klik
           nigdy nie kończył się niczym. */
        var wanted = current.options.slice();
        wanted[optionIndex] = value;
        var exact = null;
        var loose = null;
        product.variants.forEach(function (v) {
          if (v.options[optionIndex] !== value) return;
          if (!loose) loose = v;
          var same = true;
          for (var i = 0; i < wanted.length; i++) {
            if (v.options[i] !== wanted[i]) same = false;
          }
          if (same && !exact) exact = v;
        });
        var target = exact || loose;
        if (!target) return;

        var btn = el('button', 'snzw-value' + (current.options[optionIndex] === value ? ' is-active' : ''));
        btn.type = 'button';
        btn.disabled = !target.available;
        btn.title = target.available ? value : value + ' — chwilowo niedostępny';

        /* Bez miniatury przy każdej wartości. Zdjęcia wariantów Snüz to
           packshoty kremowych mebli na białym tle — w rozmiarze próbki
           wyglądają jak puste kwadraty i nie niosą informacji. Kolor pokazuje
           miniatura karty, która idzie za wyborem. */
        btn.appendChild(el('span', 'snzw-value-label', value));

        btn.addEventListener('click', function () {
          setPick(step.key, product.key, target.id);
        });
        list.appendChild(btn);
      });

      group.appendChild(list);
      wrap.appendChild(group);
    });

    return wrap;
  }

  function renderPanel() {
    var step = STEPS[state.step];
    panelsEl.innerHTML = '';

    var header = el('div', 'snzw-panel-head');
    header.appendChild(el('h2', 'snzw-panel-heading', step.heading));
    header.appendChild(el('p', 'snzw-panel-hint', step.hint));
    panelsEl.appendChild(header);

    var products = productsForStep(step.key);
    if (!products.length) {
      panelsEl.appendChild(el('p', 'snzw-empty', 'Do wybranej bazy nie mamy w tym kroku pasujących produktów.'));
    } else {
      var grid = el('div', 'snzw-cards');
      products.forEach(function (product) {
        grid.appendChild(renderProductCard(step, product));
      });
      panelsEl.appendChild(grid);

      if (!step.required) {
        var skip = el('button', 'snzw-skip', step.multi ? 'Nie potrzebuję żadnego — pomiń' : 'Nie potrzebuję — pomiń ten krok');
        skip.type = 'button';
        skip.addEventListener('click', function () {
          state.picks[step.key] = null;
          goTo(state.step + 1);
        });
        panelsEl.appendChild(skip);
      }

      /* Furtka z zawężonego kroku 1: zestaw to podpowiedź, a nie zamknięta
         ścieżka — klient musi móc zmienić zdanie co do samego łóżeczka. */
      if (step.key === 'base' && state.presetKeys) {
        var showAll = el('button', 'snzw-skip', 'Pokaż wszystkie łóżeczka');
        showAll.type = 'button';
        showAll.addEventListener('click', function () {
          state.presetKeys = null;
          render();
        });
        panelsEl.appendChild(showAll);
      }
    }

    panelsEl.appendChild(renderDeskNav());
  }

  /* Nawigacja pod panelem istnieje tylko na desktopie (CSS ją chowa niżej),
     gdzie pasek akcji jest ukryty, a panel kończy się w zasięgu wzroku. */
  function renderDeskNav() {
    var nav = el('div', 'snzw-desk-nav');

    var back = el('button', 'snzw-desk-back', 'Wstecz');
    back.type = 'button';
    back.hidden = state.step === 0;
    back.addEventListener('click', function () { goTo(state.step - 1); });
    nav.appendChild(back);

    if (state.step < STEPS.length - 1) {
      var next = el('button', 'snzw-desk-next', 'Dalej');
      next.type = 'button';
      next.disabled = state.step === 0 && !state.picks.base;
      next.addEventListener('click', function () { goTo(state.step + 1); });
      nav.appendChild(next);
    }

    return nav;
  }

  function renderSummary() {
    var items = selectedItems();
    summaryList.innerHTML = '';

    if (!items.length) {
      summaryList.appendChild(el('li', 'snzw-summary-empty', 'Nic jeszcze nie wybrano. Zacznij od łóżeczka.'));
    } else {
      items.forEach(function (item) {
        var li = el('li', 'snzw-summary-item');
        var name = el('span', 'snzw-summary-name');
        name.appendChild(document.createTextNode(item.product.title));
        if (!item.product.hasOnlyDefaultVariant) {
          name.appendChild(el('span', 'snzw-summary-variant', item.variant.title));
        }
        if (item.lead) {
          name.appendChild(el('span', 'snzw-summary-lead', 'Na zamówienie · ' + item.lead.range));
        }
        li.appendChild(name);
        li.appendChild(el('span', 'snzw-summary-price', item.variant.priceFormatted));
        summaryList.appendChild(li);
      });
    }

    var sum = total();
    totalEl.textContent = items.length ? formatMoney(sum) : '—';

    if (!items.length || threshold <= 0) {
      shippingEl.textContent = '';
      shippingEl.className = 'snzw-summary-shipping';
    } else if (sum >= threshold) {
      shippingEl.className = 'snzw-summary-shipping is-free';
      shippingEl.textContent = 'Dostawa gratis — próg ' + formatMoney(threshold) + ' osiągnięty.';
    } else {
      shippingEl.className = 'snzw-summary-shipping';
      shippingEl.textContent = 'Do darmowej dostawy brakuje ' + formatMoney(threshold - sum) + '.';
    }

    submitEl.disabled = !items.length;

    var withLead = items.filter(function (i) { return i.lead; }).length;
    noteEl.textContent = withLead
      ? 'Pozycje oznaczone „na zamówienie" sprowadzamy od producenta — całość wyślemy razem, po skompletowaniu.'
      : '';

    barEl.hidden = false;
    if (items.length) {
      barCount.textContent = items.length + ' ' + plural(items.length, 'pozycja', 'pozycje', 'pozycji');
      barTotal.textContent = formatMoney(sum);
    } else {
      barCount.textContent = 'Twój zestaw';
      barTotal.textContent = 'pusty';
    }
    barSummaryEl.disabled = !items.length;

    syncHiddenInputs(items);
  }

  /* Ukryte pola dla natywnego POST-a. Trzymamy je zsynchronizowane na bieżąco,
     żeby awaryjny submit (gdy fetch padnie) wysłał dokładnie to, co widać
     w podsumowaniu. */
  function syncHiddenInputs(items) {
    Array.prototype.slice.call(form.querySelectorAll('[data-snzw-input]')).forEach(function (n) {
      n.parentNode.removeChild(n);
    });
    items.forEach(function (item, i) {
      form.appendChild(hidden('items[' + i + '][id]', item.variant.id));
      form.appendChild(hidden('items[' + i + '][quantity]', 1));
      if (item.lead) {
        form.appendChild(hidden('items[' + i + '][properties][_lead_time]', item.lead.range));
      }
    });
  }

  function hidden(name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.setAttribute('data-snzw-input', '');
    return input;
  }

  /* Pasek ma jeden przycisk główny: na krokach 1–4 przenosi dalej, na ostatnim
     dodaje zestaw do koszyka. Jeden cel na ekranie zamiast dwóch. */
  function renderBar() {
    backEl.hidden = state.step === 0;
    var last = state.step === STEPS.length - 1;

    if (last) {
      /* Krótka etykieta, bo w belce stoi jeszcze suma i strzałka wstecz —
         "DODAJ DO KOSZYKA" nie mieści się obok nich na ekranie 375 px.
         Pełne brzmienie zostaje na przycisku w podsumowaniu. */
      nextEl.textContent = 'DO KOSZYKA';
      nextEl.disabled = selectedItems().length === 0;
    } else {
      nextEl.textContent = 'DALEJ';
      nextEl.disabled = state.step === 0 && !state.picks.base;
    }
  }

  function render() {
    renderProgress();
    renderPanel();
    renderSummary();
    renderBar();
  }

  function goTo(index) {
    if (index < 0) index = 0;
    if (index > STEPS.length - 1) index = STEPS.length - 1;
    if (index > 0 && !state.picks.base) return;
    state.step = index;
    closeSheet();
    render();
    scrollToTop();
  }

  /* Po zmianie kroku wracamy na górę panelu. Bez tego klient wylądowałby
     w środku nowej listy, w miejscu, do którego doscrollował poprzednią. */
  function scrollToTop() {
    var anchor = root.getBoundingClientRect().top + window.pageYOffset - 20;
    window.scrollTo({ top: anchor < 0 ? 0 : anchor, behavior: 'smooth' });
  }

  /* ── Arkusz podsumowania (tylko telefon) ──────────────────────────── */

  function openSheet() {
    if (!selectedItems().length) return;
    summaryEl.classList.add('is-open');
    backdropEl.hidden = false;
    barSummaryEl.setAttribute('aria-expanded', 'true');
  }

  function closeSheet() {
    summaryEl.classList.remove('is-open');
    backdropEl.hidden = true;
    barSummaryEl.setAttribute('aria-expanded', 'false');
  }

  /* ── Koszyk ───────────────────────────────────────────────────────── */

  function addToCart() {
    var items = selectedItems();
    if (!items.length) return;

    submitEl.disabled = true;
    nextEl.disabled = true;
    var label = submitEl.textContent;
    var barLabel = nextEl.textContent;
    submitEl.textContent = 'DODAJEMY…';
    nextEl.textContent = 'DODAJEMY…';

    var payload = items.map(function (item) {
      var entry = { id: item.variant.id, quantity: 1 };
      if (item.lead) entry.properties = { _lead_time: item.lead.range };
      return entry;
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: payload })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart');
        return res.json();
      })
      .then(function () {
        closeSheet();
        submitEl.textContent = 'DODANO DO KOSZYKA';
        nextEl.textContent = 'DODANO';
        var trigger = document.querySelector('.js-mini-cart-trigger');
        if (trigger) {
          trigger.click();
        } else {
          window.location.href = '/cart';
        }
        setTimeout(function () {
          submitEl.textContent = label;
          nextEl.textContent = barLabel;
          submitEl.disabled = false;
          nextEl.disabled = false;
        }, 2500);
      })
      .catch(function () {
        /* Ukryte pola są aktualne, więc natywny POST wyśle ten sam zestaw. */
        form.submit();
      });
  }

  /* ── Start ────────────────────────────────────────────────────────── */

  /* Widgety w dolnych rogach — czat Shopify Inbox po prawej, teaser Klaviyo
     po lewej — mają z-indeksy rzędu 2^31 i shadow DOM, więc nie da się ich
     przykryć ani bezpiecznie przesunąć. Po wykryciu któregokolwiek unosimy
     belkę akcji ponad ich pas, zamiast walczyć o pozycję cudzego elementu.
     Wstają asynchronicznie, stąd ponowne sprawdzenia. */
  function detectFloatingWidgets() {
    if (document.querySelector('shopify-chat, #tidio-chat, #chat-widget-container, [class*="kl-private-reset-css"]')) {
      root.classList.add('snzw-has-floating');
    }
  }
  detectFloatingWidgets();
  setTimeout(detectFloatingWidgets, 1500);
  setTimeout(detectFloatingWidgets, 4000);

  form.hidden = false;

  backEl.addEventListener('click', function () { goTo(state.step - 1); });
  nextEl.addEventListener('click', function () {
    if (state.step === STEPS.length - 1) addToCart();
    else goTo(state.step + 1);
  });
  barSummaryEl.addEventListener('click', function () {
    if (summaryEl.classList.contains('is-open')) closeSheet();
    else openSheet();
  });
  if (sheetCloseEl) sheetCloseEl.addEventListener('click', closeSheet);
  backdropEl.addEventListener('click', closeSheet);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeSheet();
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    addToCart();
  });

  /* Wejście z gotowym zestawem: /pages/snuz-kreator?zestaw=pod5,prot,sheets.
     Klucze podaje poradnik przy kaflach zestawów, więc skład kompletu ma
     jedno źródło — kafel i wypełniony kreator nie mogą się rozjechać.
     Kolory zostają domyślne, bo klient ma je poprawiać, a nie zaczynać
     od zera; dlatego lądujemy na kroku 1, a nie na podsumowaniu. */
  var presetParam = new URLSearchParams(window.location.search).get('zestaw');
  if (presetParam) {
    var keys = presetParam.split(',');
    state.presetKeys = keys;
    STEPS.forEach(function (step) {
      var chosen = config.products.filter(function (p) {
        return p.step === step.key && keys.indexOf(p.key) !== -1;
      });
      if (!chosen.length) return;
      var entries = chosen.map(function (p) {
        return { key: p.key, variantId: (firstBuyable(p) || {}).id };
      }).filter(function (e) { return e.variantId; });
      if (!entries.length) return;
      state.picks[step.key] = step.multi ? entries : entries[0];
    });
  }

  render();
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuilder);
  } else {
    initBuilder();
  }

  /* Sekcja przeładowana w edytorze motywu przychodzi jako świeży DOM bez
     flagi gotowości, więc kreator wstaje na niej od nowa. */
  document.addEventListener('shopify:section:load', initBuilder);
})();
